
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/auth/`;

const REASON_MAP = {
  mismatch: 'Captcha incorrect. Please try again.',
  expired:  'Captcha expired. Please refresh and try again.',
  missing:  'Please complete the captcha.',
  'bad-signature': 'Captcha validation error. Please refresh and try again.',
  'bad-payload':   'Captcha validation error. Please refresh and try again.',
};


export const register = async (username, nick, email, password, referralCode = null, captcha) => {
  const captchaToken = captcha?.captchaToken ?? captcha?.token ?? null;
  const captchaInput = captcha?.captchaInput ?? captcha?.input ?? captcha?.value ?? null;

  const payload = {
    username,
    nick,
    email,
    password,
    referralCode,
    ...(referralCode ? { referrerCode: referralCode } : {}),
    ...(captchaToken ? { captchaToken, captcha_token: captchaToken } : {}),
    ...(captchaInput ? { captchaInput, captcha_input: captchaInput } : {}),
  };

  const { data } = await axios.post(`${API_URL}register`, payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });

  const { user, token } = data || {};
  if (user && token) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
  }
  return { user, token };
};
export const getCurrentUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
  } catch (error) {
    console.error('Error al obtener el usuario actual:', error);
    return null;
  }
};

export const login = async (email, password, captchaToken, captchaInput) => {
  try {
    const payload = { email, password, captchaToken, captchaInput };
    const { data } = await axios.post(`${API_URL}login`, payload, {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
    });

    const { token, user } = data || {};
    if (token && user) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
    }
    return { token, user };
  } catch (error) {
    const status = error?.response?.status;
    const serverMsg = error?.response?.data?.message;
    const reason = error?.response?.data?.reason;

    if (status === 429) {
      throw new Error('Too many attempts. Try again in 15 minutes.');
    }
    if (status === 400) {
      throw new Error(REASON_MAP[reason] || serverMsg || 'Invalid request.');
    }

    throw new Error(serverMsg || 'An error occurred while signing in.');
  }
};


export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Verificar la validez del token en el servidor
export const validateToken = async (token) => {
  try {
    const response = await axios.get(`${API_URL}validate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    console.log('Validate token response:', { status: response.status, data: response.data });
    return { isValid: response.status === 200 };
  } catch (error) {
    console.error('Error validando el token:', error.response?.data || error.message);
    if (error.response && error.response.status === 401 && error.response.data.message === 'Token has expired. Please log in again.') {
      return { isValid: false, expired: true }; // Indicar específicamente que el token expiró
    }
    return { isValid: false, expired: false }; // Otros errores
  }
};

// Verificar autenticación (ajustado para usar validateToken)
export const checkAuth = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return { isAuthenticated: false };
  }

  const isValid = await validateToken(token);
  if (isValid) {
    const user = getCurrentUser();
    return { isAuthenticated: true, user };
  }
  return { isAuthenticated: false };
};

export const updateProfile = async (username, nick, email, imgUrl) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`${API_URL}profile`, { 
      username,
      nick,
      email,
      img_url: imgUrl,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (res.data && res.data.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));
      return res.data.user;
    } else {
      console.error('No user data returned from the server.');
      return null;
    }
  } catch (error) {
    console.error('Error updating profile:', error);
    return null;
  }
};